<template>
	<div class="profile-menu">
		<div class="profile-menu-top">
			<div class="profile-menu-logo">
				<nuxt-link to="/profile/my-pixellot/">
					<img alt="Pixellot logo" src="/my/images/profile-logo.png">
				</nuxt-link>
			</div>
			<div class="profile-menu-logo-asset">
				<img alt="Pixellot logo asset" src="/my/images/profile-logo-asset.svg">
			</div>
			<div class="profile-menu-hamburger" @click="toggleMenu">
				<div :class="{ active: activeMenu }" class="hamburger-menu">
					<div />
					<div class="mt-5" />
					<div class="mt-5" />
				</div>
			</div>
		</div>

		<div :class="{ 'mob-active': activeMenu }" class="profile-menu-links-wrap">
			<div class="profile-menu-links">
				<div class="profile-menu-link-wrap">
					<nuxt-link id="link-my-pixellot" class="profile-menu-link" to="/profile/my-pixellot/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/home" />
						<p>{{ $tc("sidebar.myPixellotText") }}</p>
					</nuxt-link>
				</div>
				<div class="profile-menu-link-wrap">
					<nuxt-link id="link-videos" class="profile-menu-link" to="/events/videos/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/videos" />
						<p>{{ $tc("sidebar.myVideosText") }}</p>
					</nuxt-link>
				</div>
				<div class="profile-menu-link-wrap">
					<nuxt-link id="link-profile" class="profile-menu-link" to="/profile/account/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/profile" />
						<p>{{ $tc("sidebar.youProfileText") }}</p>
					</nuxt-link>
				</div>
				<div class="profile-menu-link-wrap">
					<nuxt-link id="link-manage-plans" class="profile-menu-link" to="/profile/manage-plans/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/current-location" />
						<p>{{ $tc("sidebar.managePlansText") }}</p>
					</nuxt-link>
				</div>
				<div v-if="isActionUser" class="profile-menu-link-wrap">
					<nuxt-link id="link-uploader" class="profile-menu-link" to="/profile/uploader/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/cloud-upload" />
						<p>{{ $tc("sidebar.youUploaderText") }}</p>
					</nuxt-link>
				</div>
				<div class="profile-menu-link-wrap">
					<nuxt-link id="link-orders" class="profile-menu-link" to="/profile/my-orders/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/cart" />
						<p>{{ $tc("sidebar.myOrdersText") }}</p>
					</nuxt-link>
				</div>
				<div class="profile-menu-link-wrap">
					<a id="link-starter-guide" :href="links.starterGuide" class="profile-menu-link" target="_blank" rel="external">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/starter-guide" />
						<p>{{ $tc("sidebar.starterGuideText") }}</p>
					</a>
				</div>
				<div class="profile-menu-link-wrap">
					<a id="link-help-desk" :href="links.helpDesk" class="profile-menu-link" target="_blank" rel="external">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/question-mark" />
						<p>{{ $tc("sidebar.helpDeskText") }}</p>
					</a>
				</div>
				<div v-if="permissions.isClubAccount" class="profile-menu-link-wrap">
					<nuxt-link id="link-manage-teams" class="profile-menu-link" to="/profile/teams/">
						<SVGIcon class="profile-menu-link-svg" icon-name="profile-sidebar/pencil" />
						<p>{{ $tc("sidebar.manageTeamsText") }}</p>
					</nuxt-link>
				</div>
			</div>

			<div class="above-laptop-hidden">
				<profile-partial :active-menu="activeMenu" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SVGIcon } from '~/components/interface'
import { ProfilePartial } from '~/components/particles/index'

export default {
	name: 'ProfileSidebar',
	components: {
		ProfilePartial,
		SVGIcon
	},
	data: () => ({
		activeMenu: false
	}),
	computed: {
		...mapGetters({
			permissions: 'user/permissions',
			cameraFlow: 'plans/cameraFlow',
			isActionUser: 'plans/isActionUser'
		}),

		links () {
			switch (this.cameraFlow) {
					case 'air':
						return {
							starterGuide: '/support-center/air-faq-support/',
							helpDesk: '/support-center/'
						}
					case 'action':
					default:
						return {
							starterGuide: '/action-support-center/action-get-started-guide/',
							helpDesk: '/action-support-center/'
						}
			}
		}
	},
	watch: {
		$route: {
			deep: true,
			handler () {
				this.activeMenu = false // for mobile hamburger
			}
		}
	},
	methods: {
		toggleMenu () {
			this.activeMenu = !this.activeMenu
		}
	}
}
</script>
